<template>
    <div>
        <Loading/>
        <MenuInterno/>
        <span><strong> UNIDADES </strong></span>

        <div v-if="listagem == 'listagem'" class="mt-5">
            <div class="text-right mb-2">
                <button class="btn btn-sm btn-success" @click="viewAdicionar">Adicionar Unidade</button>
            </div>
            <table id="tabela" class="table table-striped table-responsive-sm">
                <thead>
                <tr>
                    <th>Id</th>
                    <th class="text-center">Unidades</th>
                    <th class="text-center">Tipo da Unidade</th>
                    <th class="text-center">Ações</th>
                </tr>
                </thead>
            </table>
        </div>
        <div v-else-if="listagem == 'cadastro'">
            <UnidadesCadastro/>
        </div>
        <div v-else-if="listagem == 'editar'">
            <UnidadesEditar :id='id'/>
        </div>

    </div>

</template>

<script>
    import Loading from '@/components/Loading'
    import UnidadesCadastro from '../unidades/UnidadesCadastro.vue'
    import UnidadesEditar from '../unidades/UnidadesEditar.vue'
    import MenuInterno from '@/components/adm/MenuInterno'

    var gridTipoConta;

    export default {
        name: 'UnidadesListagem',
        components: {
            MenuInterno,
            Loading,
            UnidadesCadastro,
            UnidadesEditar
        },
        data() {
            return {
                isModalVisible: false,
                listagem: 'listagem',
                paginaTop: '',
                dados: null,
                id: ''
            }
        },
        methods: {
            viewAdicionar() {
                this.listagem = 'cadastro'
                this.paginaTop = 'ADICIONAR UNIDADES'
                $('#tabela').parents('div.dataTables_wrapper').first().hide();
            },
            viewEditar() {
                this.listagem = 'editar'
                this.paginaTop = 'EDITAR UNIDADES'
            }
        },
        mounted: function () {
            let thiss = this;
            let swall = this.$swal;

            $('#tabela').DataTable({
                "oLanguage": {
                    "sSearch": "Pesquisar:",
                     "sEmptyTable": "Nenhum dado encontrado",
                    "sZeroRecords": "Nenhum dado encontrado",
                    "oPaginate": {
                        "sNext": "Próximo",
                        "sPrevious": "Anterior",
                    },
                    "sLengthMenu": "Mostrar _MENU_ dados",
                    "sInfoFiltered": " - (filtrado de _MAX_ dados)",
                    "sInfo": "Mostrando _START_ até _END_ de _TOTAL_ dados",
                },
                "ajax": {
                    "url": axios.defaults.baseURL + "/api/contas-consumo/unidades",
                    dataSrc: '',
                    headers: {
                        'Authorization': `Bearer ${store.getters.pegaAccessToken}`
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        api.geraNovoTokenDatatable(jqXHR);
                    }
                },
                "columns": [
                    {"data": "ba02_id", visible: false},
                    {"data": "ba02_unidade"},
                    {"data": "tp00_descricao"},
                    {
                        targets: [4],
                        width: '10%',
                        orderable: false,
                        mData: data => criarBotoes(data.ba02_id)
                    }
                ],
                'fnDrawCallback': function () {

                    $('.editar').on('click', function () {
                        var dados = $(this).data('id');
                        thiss.id = dados;
                        thiss.listagem = 'editar'
                        thiss.paginaTop = 'EDITAR'
                        $('#tabela').parents('div.dataTables_wrapper').first().hide();
                    })
                    $('.excluir').on('click', function () {
                        var dados = $(this).data('id');
                        thiss.id = dados;

                        swall({
                            title: "Atenção!",
                            text: "Deseja realmente excluir a Unidade selecionada?",
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonText: 'Sim',
                            cancelButtonText: "Não!"
                        })
                            .then(
                                function () {
                                    api.enviarRequisicao('delete', '/api/contas-consumo/unidades/' + thiss.id)
                                        .then(
                                            swall('Atenção', 'A Unidade foi deletada com sucesso', 'success')
                                                .then(
                                                    function () {
                                                        history.go(0);
                                                    }
                                                )
                                        )
                                        .catch(error => {
                                            swall('Erro', 'A Unidade já está sendo usada', 'error')
                                        });
                                },
                                function () {
                                    return false;
                                });

                    })

                }
            });

            function criarBotoes(id, ctrl) {
                if (ctrl != null) {
                    return '<a href="#" class="btnEditar' + ctrl + ' btn btn_editar_rh btn-default btn-sm">' +
                        '<i class="fa fa-edit" data-toggle="tooltip" title="Editar"></i>' +
                        '</a>' +
                        '<a href="#" data-id="' + id + '" class="btn btn-sm btn-info' + ctrl + ' btn btn-default btn-sm">' +
                        '<i class="fa fa-trash" data-toggle="tooltip" title="Deletar"></i>' +
                        '</a>';
                } else {
                    return "<button class='btn btn-sm editar' data-id='" + id + "'><i class='fa fa-edit text-info' ></i></button>" +
                        "<button class='btn btn-sm excluir' data-id='" + id + "'><i class='fa fa-trash text-danger'></i></button>";
                }
            }
        }
    }

</script>

<style scoped>

    a {
        background-color: #18A689;
        color: #fff;
        font-size: 12px;
        text-decoration: none;
    }


</style>
